import { mutation } from '../../../../1_shared/api/apiInstance';
import { IEvents } from '../../../Schedule/module/interfaces/IEvents';

import { IModalScheduleAdd } from './interfaces/IModalScheduleAdd';

export const addScheduleOnWeek = mutation<IModalScheduleAdd, IEvents[]>();
